module.exports = "./assets/images/avatar-17.svg";